/**
 * @file Re-exports the distribution schedule summary.
 */
import DistributionsScheduleSummary from "./DistributionsScheduleSummary";

export default DistributionsScheduleSummary;
